module.exports = __webpack_public_path__ + "static/media/testimonio4.a27f3a89.jpg";